<template>
  <div class="container-fluid mt-5">
    <div>
      <card
        class="no-border-card"
        body-classes="px-0 pb-1"
        footer-classes="pb-2"
      >
        <template slot="header">
          <div class="row">
            <div class="col-8">
              <h3 class="mb-0 view-header-buttons">
                <span class="text-before-button mr-4">{{ product.name }}</span>
                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_EDIT_PRODUCTS) &&
                    product.status != STATUS_ACTIVE &&
                    product.status !== STATUS_DELETED
                  "
                  type="success"
                  icon
                  size="sm"
                  :title="$t('PRODUCTS.ACTIVATE')"
                  @click="activate()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-check"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_EDIT_PRODUCTS) &&
                    product.status != STATUS_INACTIVE &&
                    false
                  "
                  type="warning"
                  icon
                  size="sm"
                  :title="$t('PRODUCTS.DEACTIVATE')"
                  @click="deactivate()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-times"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_EDIT_PRODUCTS) &&
                    product.status !== STATUS_DELETED
                  "
                  type="warning"
                  icon
                  size="sm"
                  :title="$t('PRODUCTS.SET_BACKORDER')"
                  @click="
                    () => {
                      setToBackorderModalOpened = true;
                      replacements = [];
                    }
                  "
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-random"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="
                    $currentUserCan($permissions.PERM_EDIT_PRODUCTS) &&
                    product.status === STATUS_DELETED
                  "
                  type="warning"
                  icon
                  size="sm"
                  :title="$t('PRODUCTS.REPLACEMENTS')"
                  @click="openDeletedReplacementSelector"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-random"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="$currentUserCan($permissions.PERM_EDIT_PRODUCTS)"
                  type="primary"
                  icon
                  size="sm"
                  @click="editProduct()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-edit"></i>
                  </span>
                </base-button>

                <base-button
                  v-if="$currentUserCan($permissions.PERM_DELETE_PRODUCTS)"
                  type="danger"
                  icon
                  size="sm"
                  @click="deleteProduct()"
                >
                  <span class="btn-inner--icon">
                    <i class="fas fa-trash"></i>
                  </span>
                </base-button>
              </h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack()"
                type="button"
                class="btn btn-sm btn-primary"
              >
                {{ $t("COMMON.RETURN_TO_LIST") }}
              </base-button>

              <notification-subscription
                :objectType="'products'"
                :objectId="product.id"
                :events="{
                  UPDATE: $t('NOTIFICATIONS.EVENT_UPDATE'),
                  DELETE: $t('NOTIFICATIONS.EVENT_DELETE'),
                }"
              />
            </div>
          </div>
        </template>
        <div>
          <div
            class="col-12 justify-content-center justify-content-sm-between flex-wrap tabs-wrapper"
          >
            <tabs
              fill
              class="flex-column flex-md-row"
              tabNavWrapperClasses="nav-wrapper"
              tabNavClasses="nav nav-pills nav-fill"
              value="global"
              :key="renderKey"
            >
              <card shadow>
                <tab-pane title="global" id="1" :active="true">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GLOBAL") }}
                  </span>
                  <product-view-global :product="product" />
                </tab-pane>

                <tab-pane title="gallery" id="2">
                  <span slot="title">
                    <i class="ni ni-cloud-upload-96" />
                    {{ $t("COMMON.GALLERY") }}
                  </span>
                  <product-view-gallery :product="product" />
                </tab-pane>

                <tab-pane
                  title="supplier-products"
                  id="3"
                >
                  <span slot="title">
                    <i class="ni ni-circle-08" />
                    {{ $t("COMMON.SUPPLIERS") }}
                  </span>
                  <product-view-suppliers :product="product" />
                </tab-pane>

                <tab-pane
                  title="purchases-orders"
                  id="4"
                  v-if="product.can_be_purchased"
                >
                  <span slot="title">
                    <i class="ni ni-circle-08" />
                    {{ $t("COMMON.PURCHASES_ORDERS") }}
                  </span>
                  <product-view-purchases-orders :product="product" />
                </tab-pane>

                <tab-pane title="warehouses-products" id="5">
                  <span slot="title">
                    <i class="fa fa-building" />
                    {{ $t("PRODUCTS.WAREHOUSES_PRODUCTS") }}
                  </span>
                  <product-view-warehouses-products :product="product" />
                </tab-pane>

                <tab-pane
                  title="files"
                  id="998"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_FILES)"
                >
                  <span slot="title">
                    <i class="ni ni-folder-17" />
                    {{ $t("COMMON.FILES") }}
                  </span>
                  <list-file-component :object="product" />
                </tab-pane>

                <tab-pane
                  title="logs"
                  id="999"
                  v-if="$currentUserCan($permissions.PERM_VIEW_ANY_LOGS)"
                >
                  <span slot="title">
                    <i class="fa fa-file" />
                    {{ $t("COMMON.LOGS") }}
                  </span>
                  <product-view-logs :product="product" />
                </tab-pane>
              </card>
            </tabs>
          </div>
        </div>
      </card>
    </div>

    <modal
      :show.sync="setToBackorderModalOpened"
      modal-classes="modal-secondary"
      size="xl"
    >
      <div>
        <h2>
          {{ $t("PRODUCTS.SELECT_REPLACEMENTS") }}
        </h2>
        <div>
          <base-input
            :label="`${$t('PRODUCTS.RETURN_TO_STOCK_DATE')} (*)`"
            :placeholder="$t('PRODUCTS.RETURN_TO_STOCK_DATE')"
          >
            <flat-picker
              :config="{
                allowInput: true,
                minDate: 'today',
                locale: $flatPickrLocale(),
              }"
              class="form-control datepicker"
              v-model="backOrderData.return_to_stock_date"
            >
            </flat-picker>
          </base-input>

          <base-input
            :label="`${$t('COMMON.PRODUCTS')}`"
            :placeholder="$t('COMMON.PRODUCTS')"
          >
            <products-selector
              :products="product.replacements"
              :filterIdsNotIn="[product.id]"
              :filterable="true"
              :showAll="false"
              :collapseTags="false"
              :filterIsModel="true"
              :organization="product.organization.id"
              @productChanged="
                (products) => {
                  backOrderData.replacements = products.map((item) => item.id);
                }
              "
            />
          </base-input>

          <base-input
            :label="`${$t('PRODUCTS.BACKORDER_NOTE')}`"
            :placeholder="$t('PRODUCTS.BACKORDER_NOTE')"
            input-classes="form-control-alternative"
          >
            <textarea
              class="form-control"
              rows="3"
              v-model="backOrderData.backorder_note"
              :placeholder="$t('PRODUCTS.BACKORDER_NOTE_HELPER')"
            ></textarea>
          </base-input>

          <div class="my-4">
            <base-button
              type="button"
              class="btn btn-sm btn-primary"
              native-type="submit"
              @click="setBackorder()"
            >
              {{
                product.status != STATUS_BACKORDER
                  ? $t("PRODUCTS.SET_BACKORDER")
                  : $t("PRODUCTS.UPDATE_BACKORDER")
              }}
            </base-button>
          </div>
        </div>
      </div>
    </modal>

    <modal
      :show.sync="backorderModalOpened"
      modal-classes="modal-secondary"
      size="lg"
    >
      <div>
        <div class="d-flex align-items-center mb-3">
          <i
            class="fas fa-exclamation-triangle text-warning mr-2"
            style="font-size: 24px"
          ></i>
          <h2 class="mb-0">
            {{ $t("PRODUCTS.PRODUCT_IN_BACKORDER") }}
          </h2>
        </div>

        <div v-if="product">
          <div class="mb-3">
            <strong>{{ $t("COMMON.PRODUCT") }}:</strong> {{ product.name }}
          </div>

          <div class="mb-3" v-if="product.return_to_stock_date">
            <strong>{{ $t("PRODUCTS.RETURN_TO_STOCK_DATE") }}:</strong>
            {{ $timeZoneDateFormat(product.return_to_stock_date, "LL") }}
            <br />
            <small class="text-muted">
              {{
                $t("PRODUCTS.PRODUCT_BACK_IN_STOCK_ON_X", {
                  date: $timeZoneDateFormat(product.return_to_stock_date, "LL"),
                })
              }}
            </small>
          </div>

          <div v-if="product.replacements && product.replacements.length > 0">
            <strong>{{ $t("PRODUCTS.REPLACEMENTS") }}:</strong>
            <div class="mt-2">
              <div
                v-for="replacement in product.replacements"
                :key="replacement.id"
                class="mb-1"
              >
                <object-link :object="replacement" />
              </div>
            </div>
          </div>

          <div class="mb-3" v-if="product.backorder_note">
            <strong>{{ $t("PRODUCTS.BACKORDER_NOTE") }}:</strong>
            <div class="mt-1">{{ product.backorder_note }}</div>
          </div>

          <div class="alert alert-info mt-3">
            <i class="fas fa-info-circle mr-2"></i>
            {{ $t("PRODUCTS.BACKORDER_INFO_MESSAGE") }}
          </div>
        </div>

        <div class="mt-4 text-right">
          <base-button type="secondary" @click="backorderModalOpened = false">
            {{ $t("COMMON.CLOSE") }}
          </base-button>
        </div>
      </div>
    </modal>

    <modal
      :show.sync="deletedReplacementSelectorModalOpened"
      modal-classes="modal-secondary"
      size="lg"
    >
      <div>
        <div class="d-flex align-items-center mb-3">
          <i
            class="fas fa-exclamation-triangle text-danger mr-2"
            style="font-size: 24px"
          ></i>
          <h2 class="mb-0">{{ $t("PRODUCTS.SELECT_REPLACEMENTS") }}</h2>
        </div>

        <p class="text-muted">
          {{ $t("PRODUCTS.DELETED_PRODUCT_REPLACEMENT_REQUIRED") }}
        </p>

        <base-input :label="$t('PRODUCTS.REPLACEMENTS')">
          <products-selector
            :products="product.replacements"
            :filterIdsNotIn="[product.id]"
            :filterable="true"
            :showAll="false"
            :collapseTags="false"
            :filterIsModel="true"
            :organization="product.organization ? product.organization.id : null"
            @productChanged="onDeletedReplacementSelection"
          />
        </base-input>

        <base-input :label="$t('PRODUCTS.BACKORDER_NOTE')">
          <textarea
            class="form-control"
            rows="3"
            v-model="deletedReplacementNote"
            :placeholder="$t('PRODUCTS.BACKORDER_NOTE_HELPER')"
          ></textarea>
        </base-input>

        <div class="mt-4 d-flex justify-content-end">
          <base-button
            type="secondary"
            class="btn btn-sm btn-secondary mr-2"
            @click="deletedReplacementSelectorModalOpened = false"
          >
            {{ $t("COMMON.CANCEL") }}
          </base-button>
          <base-button
            type="primary"
            class="btn btn-sm btn-primary"
            :disabled="
              savingDeletedReplacements || !deletedReplacementSelection.length
            "
            @click="saveDeletedProductReplacements"
          >
            <i
              class="fas fa-spinner fa-spin mr-2"
              v-if="savingDeletedReplacements"
            ></i>
            {{ $t("COMMON.UPDATE") }}
          </base-button>
        </div>
      </div>
    </modal>

    <modal
      :show.sync="deletedReplacementListModalOpened"
      modal-classes="modal-secondary"
      size="lg"
    >
      <div>
        <div class="d-flex align-items-center mb-3">
          <i
            class="fas fa-info-circle text-primary mr-2"
            style="font-size: 24px"
          ></i>
          <h2 class="mb-0">{{ $t("PRODUCTS.REPLACEMENTS") }}</h2>
        </div>

        <div v-if="productHasReplacements">
          <div
            v-for="replacement in product.replacements"
            :key="replacement.id"
            class="mb-2"
          >
            <object-link :object="replacement" />
          </div>
        </div>
        <div v-else class="text-muted">
          {{ $t("COMMON.NONE") }}
        </div>

        <div class="mt-3" v-if="product.backorder_note">
          <strong>{{ $t("PRODUCTS.BACKORDER_NOTE") }}:</strong>
          <div class="mt-1">{{ product.backorder_note }}</div>
        </div>

        <div class="mt-4 text-right">
          <base-button
            type="secondary"
            @click="deletedReplacementListModalOpened = false"
          >
            {{ $t("COMMON.CLOSE") }}
          </base-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import moment from "moment";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
  Select,
  Option,
  Button,
} from "element-ui";
import { cloneDeep } from "lodash";
import swal from "sweetalert2";
import requestErrorMixin from "@/mixins/request-error-mixin";
import { Tabs, TabPane } from "@/components";
import {
  STATUS_ACTIVE,
  STATUS_INACTIVE,
  STATUS_BACKORDER,
  STATUS_DELETED,
} from "@/constants/products";
import flatPicker from "vue-flatpickr-component";
import ListFileComponent from "@/components/File/ListFileComponent.vue";
import NotificationSubscription from "@/components/NotificationSubscription.vue";
import defaultProduct from "./defaultProduct";
import ProductViewGlobal from "./partials/ProductViewGlobal.vue";
import ProductViewLogs from "./partials/ProductViewLogs.vue";
import ProductViewGallery from "./partials/ProductViewGallery.vue";
import ProductViewSuppliers from "./partials/ProductViewSuppliers.vue";
import ProductsSelector from "@/components/ProductsSelector.vue";
import ProductViewPurchasesOrders from "./partials/ProductViewPurchasesOrders.vue";
import ProductViewWarehousesProducts from "./partials/ProductViewWarehousesProducts.vue";
import products from "../../../../i18n/fr/products";

export default {
  layout: "DashboardLayout",

  components: {
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
    Tabs,
    TabPane,
    ProductViewGlobal,
    ProductViewGallery,
    ProductViewLogs,
    ListFileComponent,
    NotificationSubscription,
    ProductViewSuppliers,
    ProductViewPurchasesOrders,
    ProductViewWarehousesProducts,
    ProductsSelector,
    flatPicker,
  },

  mixins: [requestErrorMixin],

  data() {
    return {
      renderKey: 0,
      product: cloneDeep(defaultProduct),
      backorderModalOpened: false,
      setToBackorderModalOpened: false,
      STATUS_ACTIVE,
      STATUS_INACTIVE,
      STATUS_BACKORDER,
      STATUS_DELETED,
      console: console,
      backOrderData: {
        replacements: [],
        return_to_stock_date: null,
        backorder_note: "",
      },
      deletedReplacementSelectorModalOpened: false,
      deletedReplacementListModalOpened: false,
      deletedReplacementSelection: [],
      deletedReplacementNote: "",
      savingDeletedReplacements: false,
    };
  },

  computed: {
    productHasReplacements() {
      return (
        this.product &&
        Array.isArray(this.product.replacements) &&
        this.product.replacements.length > 0
      );
    },
  },

  watch: {},

  created() {
    this.get();
  },

  methods: {
    async get() {
      try {
        const id = this.$route.params.id;
        await this.$store.dispatch("products/get", id);
        this.product = this.$store.getters["products/product"];
        this.renderKey++;

        if (this.product.status == STATUS_BACKORDER) {
          this.backorderModalOpened = true;
          this.backOrderData.return_to_stock_date =
            this.product.return_to_stock_date;
          this.backOrderData.backorder_note = this.product.backorder_note || "";
        }

        this.handleReplacementModals();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async editProduct() {
      this.$router.push({
        name: "Edit Product",
        params: { id: this.product.id },
      });
    },

    async deleteProduct() {
      const confirmation = await swal.fire({
        title: this.$t("PRODUCTS.DELETE_THIS_PRODUCT"),
        type: "question",
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: this.$t("COMMON.YES"),
        cancelButtonText: this.$t("COMMON.NO"),
        confirmButtonClass: "btn btn-primary",
        cancelButtonClass: "btn btn-warning",
      });

      try {
        if (confirmation.value === true) {
          await this.$store.dispatch("products/destroy", this.product.id);
          await this.goBack();
          this.$notify({
            type: "success",
            message: this.$t("PRODUCTS.PRODUCT_DELETED"),
          });
        }
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
    },

    async activate() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });

      try {
        await this.$store.dispatch("products/activate", this.product.id);
        this.product = this.$store.getters["products/product"];
        this.handleReplacementModals();
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.PRODUCT_ACTIVATED"),
        });
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
      swal.close();
    },

    async deactivate() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });

      try {
        await this.$store.dispatch("products/deactivate", this.product.id);
        this.product = this.$store.getters["products/product"];
        this.handleReplacementModals();
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.PRODUCT_DEACTIVATED"),
        });
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
      swal.close();
    },

    async setBackorder() {
      swal.fire({
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading();
        },
      });

      try {
        await this.$store.dispatch("products/setBackorder", {
          id: this.product.id,
          replacements: this.backOrderData.replacements,
          return_to_stock_date: this.backOrderData.return_to_stock_date
            ? moment(this.backOrderData.return_to_stock_date).toISOString()
            : null,
          backorder_note: this.backOrderData.backorder_note || null,
        });
        this.handleReplacementModals();
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.PRODUCT_SET_BACKORDER"),
        });
        this.backOrderData = {
          replacements: [],
          return_to_stock_date: null,
          backorder_note: "",
        };
        // this.product = this.$store.getters["products/product"];
        this.get();
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      }
      this.setToBackorderModalOpened = false;
      swal.close();
    },

    handleReplacementModals() {
      this.deletedReplacementSelection = cloneDeep(
        (this.product && this.product.replacements) || []
      );
      this.deletedReplacementNote = this.product?.backorder_note || "";
      this.deletedReplacementSelectorModalOpened = false;
      this.deletedReplacementListModalOpened = false;

      if (!this.product || this.product.status !== STATUS_DELETED) {
        return;
      }

      if (!this.product.replacements || !this.product.replacements.length) {
        this.deletedReplacementSelectorModalOpened = true;
        return;
      }

      this.deletedReplacementListModalOpened = true;
    },

    onDeletedReplacementSelection(products) {
      console.log("onDeletedReplacementSelection", products);
      this.deletedReplacementSelection = products;
    },

    openDeletedReplacementSelector() {
      this.deletedReplacementSelection = cloneDeep(
        (this.product && this.product.replacements) || []
      );
      this.deletedReplacementNote = this.product?.backorder_note || "";
      this.deletedReplacementSelectorModalOpened = true;
    },

    async saveDeletedProductReplacements() {
      if (!this.product || !this.deletedReplacementSelection.length) {
        return;
      }

      this.savingDeletedReplacements = true;
      const payload = cloneDeep(this.product);
      payload.replacements = this.deletedReplacementSelection.map(
        (replacement) => ({
          type: "products",
          id: replacement.id,
        })
      );
      payload.relationshipNames = payload.relationshipNames || [];
      if (!payload.relationshipNames.includes("replacements")) {
        payload.relationshipNames.push("replacements");
      }
      payload.backorder_note = this.deletedReplacementNote || null;

      try {
        await this.$store.dispatch("products/update", payload);
        this.product = this.$store.getters["products/product"];
        this.renderKey++;
        this.$notify({
          type: "success",
          message: this.$t("PRODUCTS.REPLACEMENTS_UPDATED"),
        });
        this.deletedReplacementSelectorModalOpened = false;
        this.handleReplacementModals();
      } catch (error) {
        await this.showRequestError(error);
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.savingDeletedReplacements = false;
      }
    },

    goBack() {
      this.$router.push({ name: "List Products" });
    },
  },
};
</script>
